
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learning-path",
      function () {
        return require("private-next-pages/learning-path.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learning-path"])
      });
    }
  